<template lang="pug">
  v-container.px-10(fluid)
    v-row
      v-col
        .section__title {{ $t('Contact.generalInfo') }}
    //- v-row
    //-   v-col
    //-     app-datetime-picker(
    //-       :disableTime="false",
    //-       label="Date Pick Up From"
    //-       v-model="dateExample"
    //-     )
    v-row
      v-col(cols="2")
        app-entity-autocomplete(
          :entity="$findEntity('BusinessScope')",
          v-model="instance.businessScope",
          :init="instance.businessScope",
          :label="$t('Contact.businessScope')",
        )
      v-col(cols="1")
        v-text-field(
          v-model="instance.title",
          :label="$t('Contact.title')",
          :error-messages="errors['contact.title']",
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.name",
          :label="$t('Contact.name')",
          :error-messages="errors['contact.name']",
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.lastName",
          :label="$t('Contact.lastName')",
          :error-messages="errors['contact.lastName']",
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.preferredName",
          :label="$t('Contact.preferredName')",
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.preferredLanguage",
          :label="$t('Contact.preferredLanguage')",
        )
      v-col(cols="4")
        v-text-field(
          v-model="instance.eMail",
          :label="$t('Contact.eMail')",
          :error-messages="errors['contact.eMail']",
        )
      v-col(cols="4")
        v-text-field(
          v-model="instance.eMail2",
          :label="$t('Contact.eMail2')",
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.phoneNumber",
          :label="$t('Contact.phoneNumber')",
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.phoneNumber2",
          :label="$t('Contact.phoneNumber2')",
        )
      v-col(cols="4")
        v-text-field(
          filled,
          v-model="instance.remarks",
          :label="$t('Contact.remarks')",
          :error-messages="errors['contact.Remarks']",
        )
    v-row(v-if="showParties")
      v-col(cols="12")
        .section__title {{ $t('Common.addEntity', { entity: $tc('Party._name', 2) }) }}
        .section__subtitle {{ $t("Contact.availablePartyMessage") }}

    v-container(v-if="showParties")
      v-row
        v-col(cols="6")
          h2.primary--text {{ $t("Contact.searchForParties") }}
          app-entity-autocomplete(
            :entity="$findEntity('Party')",
            :emit="true",
            v-model="where",
            @input="getPartyList",
          )
          v-card(v-if="hasAvailableParties")
            v-list
              v-list-item(
                v-for="party in partyList"
                :key="party.uid"
              )
                v-list-item-content
                  v-list-item-title {{party.name}}
                v-list-item-icon
                  v-icon(@click="addParty(party)") mdi-plus
        v-col(cols="6")
          h2.primary--text {{ $t('Contact.linkedParties') }}
          v-card(v-if="filteredPartyList.length")
            v-list
              v-list-item(
                v-for="party in filteredPartyList"
                :key="party.uid"
              )
                v-list-item-content
                  v-list-item-title {{party.party.name}}
                v-list-item-icon
                  v-icon(@click="removeParty(party)") mdi-close

</template>
<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
  name: 'contact',
  mixins: [EntityMixin],
  props: {
    showParties: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({

    businessScopes: [],
    where: null,
    partyList: [],

    whereList: null,
    timer: null,
    wait: 500,
    dateExample: null,

    loading: false,
  }),
  computed: {
    uid () {
      return this.$route.params.item
    },
    hasAvailableParties() {
      return !_.isEmpty(this.partyList);
    },
    filteredPartyList() {
      return (this.instance.contactParties || []).filter(x => x.entityState !== ENV.ENTITY.STATE.DELETED);
    },
    errors(){
     return this.$store.state.errors;
    }
  },
  methods: {
    async getPartyList () {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
          this.loading = true
          try {
            this.partyList = (await axios.get('Party', { params: { where: this.where, pageSize: 20 }})).data.data;
          } catch (err) {}
          this.loading = false
      }, this.wait)
    },

    addParty(party) {
      // If not found, then add ContactParty. Else, if it is deleted (cannot see it) change to added.
      let f = this.instance.contactParties.find(x => x.party.uid === party.uid);
      if(!f) {
        this.instance.contactParties.push({ party: party, entityState: ENV.ENTITY.STATE.ADDED, _Entity: "ContactParty" });
      } else {
        if(f.entityState === ENV.ENTITY.STATE.DELETED) f.entityState = ENV.ENTITY.STATE.ADDED;
      }

      if(this.instance.entityState === 0 ||this.instance.entityState === 1) this.instance.entityState = 3;
    },
    removeParty(party) {
      // If added remove from list, else just convert to delete
      if(party.entityState === ENV.ENTITY.STATE.ADDED) {
        this.instance.contactParties = this.instance.contactParties.filter(x => x.party.uid !== party.party.uid);
      } else {
        const i = _.findIndex(this.instance.contactParties, x => x.party.uid === party.party.uid);
        if(i !== -1) this.instance.contactParties.splice(i, 1, { ...party, entityState: ENV.ENTITY.STATE.DELETED, _Entity: "ContactParty" });
      }

      if(this.instance.entityState === 0 || this.instance.entityState === 1) this.instance.entityState = 3;
    },

    /* TODO: docs */
    async load () {
      this.instance = {
        contactParties: [],
        businessScope: this.$store.state.user.user.businessScope,
        ...this.instance,
      }
      if (this.uid) {
        try {
          this.instance = (await axios.get(`Contact/${this.uid}?load[]=BusinessScope&load[]=ContactParties&load[]=ContactParties.Party&load[]=ExtraData`, {
            _Entity: 'Contact',
            uid: this.uid
          })).data
          this.instance.entityState = 3
        } catch (error) {
          console.error(error)
        }
      }
      this.loading = false
    }
  },
  async created () {
    await this.load()
    await this.getPartyList()
    // console.log(moment.tz.names());
  },
}
</script>
<style>
.v-text-field--filled input {
  margin-top: 16px !important;
}

.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: inherit !important;
}
</style>
